// extracted by mini-css-extract-plugin
export default {"section":"dhbrm__section--bb17b","sectionTitle":"dhbrm__sectionTitle--ae494","stickyTitle":"dhbrm__stickyTitle--f978f"};